export default __webpack_public_path__ + "images/trial02.svg";